import { render, staticRenderFns } from "./LayoutThumbnail.vue?vue&type=template&id=5089ef24&scoped=true&"
import script from "./LayoutThumbnail.vue?vue&type=script&lang=js&"
export * from "./LayoutThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./LayoutThumbnail.vue?vue&type=style&index=0&id=5089ef24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089ef24",
  null
  
)

export default component.exports